<template>
    <div v-if="image.phototype!=360"
         :style="{'background-image': 'url(\'' + getImagePath() + '\')'}">
    </div>
    <div v-else :id="'image_' + this.image.pdphotoid" style="width:100%; height:100%;">
    </div>
</template>

<script>
import process from 'shelljs'
import {Viewer} from 'photo-sphere-viewer';
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'


export default {
  name: 'photodisplay',
  data () {
    return {}
  },
  components: {

  },
  mounted () {
    console.log('Photodisplay Mounted ', this.image)
    if(this.image.phototype == '360') {
      console.log('Mounted 360')
      this.initViewer()
    }
  },
  beforeDestroy () {
    console.log('Photodisplay Destroyed ')
  },
  props: {
      image: {
        type: Object,
        required: true,
        default: () => ({}) // Sicherheitshalber ein leeres Objekt
      },
      moveable: {
        type: Boolean,
        default: false
      }
  },
  methods: {
    updateSize() {
      if (this.viewer) {
        this.viewer.autoSize();
        console.log("Viewer resized!");
      }
    },
    initViewer() {
      let _this = this;
      let container = document.getElementById('image_' + this.image.pdphotoid);

      this.$nextTick(() => {
        this.viewer = new Viewer({
          container: container,
          // panorama: this.src,
          panorama: _this.getImagePath(),
          touchmoveTwoFingers: false,
          autorotateSpeed: '0.5rpm', // Geschwindigkeit: z. B. 2 Umdrehungen pro Minute
          autorotateDelay: 1000,   // Startverzögerung nach 1 Sekunde
          autorotateLat: 0,
          navbar: false,
          mousewheel: true
        });
        if (!_this.moveable) {
          this.viewer.setOption('mousemove', false); // Deaktiviert das Umschauen mit der Maus
          // this.viewer.setOption('touchview', false); // Deaktiviert das Umschauen per Touch
        }
      });

    },


    getImagePath() {
      let photo = this.image
      const projectid = this.$route.params.id
      const jwt = localStorage.getItem('jwt');
      console.log('getImagePath', projectid, photo.pdphotoid, jwt);
      return `${process.env.VUE_APP_GET_METHOD_URL}img&type=l&projectid=${projectid}&id=${photo.pdphotoid}&token=${jwt}`
    },
  }
}


</script>


<style>

.psv-container canvas {
  cursor: move;

}



</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/common/photodisplay.vue